import ApplicationAdapter from './application';

export default class Superbill extends ApplicationAdapter {
  urlForCreateRecord(_modelName, snapshot) {
    let appointmentId = snapshot.adapterOptions.appointmentId;

    return `${this.buildURL('appointment', appointmentId)}/superbills`;
  }
}
